module.exports = __webpack_public_path__ + "img/Secure-W.5a2206e.svg";